import { render, staticRenderFns } from "./ProcessInstanceTabs.vue?vue&type=template&id=4d7421b0&scoped=true"
import script from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceTabs.vue?vue&type=style&index=0&id=4d7421b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7421b0",
  null
  
)

export default component.exports